import { createFileRoute, redirect } from "@tanstack/react-router"
import { extractCallbackPath, hasAuthCookie } from "~/lib/authConfig"
import z from "zod"
import { SignInPage } from "./-AuthSigninPage"

// Define the search schema for this route
const signInSearchSchema = z.object({
  callbackUrl: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute("/auth/signin")({
  validateSearch: signInSearchSchema,
  // Pre-mount auth check: if the user already has a session cookie, send them
  // to `callbackUrl` (or the default landing) without painting the signin form.
  // The post-mount useEffect inside the component handles the rarer case where
  // the session becomes authenticated AFTER mount (e.g., cross-tab sync).
  beforeLoad: ({ search }) => {
    if (search.error) return // let the page render to surface the error
    if (hasAuthCookie()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router uses non-Error throw for control flow
      throw redirect({ to: extractCallbackPath(search.callbackUrl), replace: true })
    }
  },
  component: SignInPage,
})
